export const paginationPagesSlice = (
  totalPagesCount,
  currentPage
) => {
  // array of numbers from 0 to totalPageCount
  const arrayOfPages = Array.from(
    { length: totalPagesCount },
    (_, k) => k + 1
  )

  const lastPage = arrayOfPages[arrayOfPages.length - 1]

  // max value of all characters in pagination = numbers + dividers
  const maxCountOfCharacters = 7

  // shown numbers after or before dividers
  const maxCountOfShownPages = 5

  const isPageInMiddle = (currentPage) => {
    return (
      currentPage >= maxCountOfShownPages ||
      currentPage <= lastPage - maxCountOfShownPages
    )
  }

  switch (true) {
    // when empty arrayOfPages return 1 page
    case arrayOfPages.length === 0:
      return [1]

    // when max numbers without divider = maxCountOfCharacters return arrayOfPages
    case lastPage <= maxCountOfCharacters:
      return arrayOfPages

    // when current page = 1 and is less than maxCountOfSlice
    case currentPage === 1 || currentPage < maxCountOfShownPages:
      return [
        ...arrayOfPages.slice(0, maxCountOfShownPages),
        'divider',
        totalPagesCount,
      ]

    // when current page = {lastePage} (ex. 9) or currentPage = {lastPage - maxCountOfShownPages + 1} then display [1, "divider",5, 6, 7, 8, 9]
    case currentPage === lastPage ||
      currentPage > lastPage - maxCountOfShownPages + 1: {
      const sliceFrom = lastPage - maxCountOfShownPages

      return [
        1,
        'divider',
        ...arrayOfPages.slice(sliceFrom, lastPage),
      ]
    }

    // when current page is in the middle of pages then return ex. [1, "divider", 3, 4, 5, "divider", {lastPage}]
    case isPageInMiddle(currentPage): {
      const sliceFrom = currentPage - 2
      const sliceTo = currentPage + 1
      return [
        1,
        'divider',
        ...arrayOfPages.slice(sliceFrom, sliceTo),
        'divider',
        totalPagesCount,
      ]
    }
    default:
      return arrayOfPages
  }
}
